import { MediaSchema, OptionalMediaSchema } from '../api/fragments/media';

export const hasMedia = (
  media: OptionalMediaSchema['media']
): media is MediaSchema['media'] => {
  switch (media.type) {
    case 'image': {
      return Boolean(media.image?.node);
    }

    case 'video': {
      return Boolean(media.video?.node);
    }

    case 'youtube': {
      return Boolean(media.youtubeId);
    }

    case 'vimeo': {
      return Boolean(media.vimeoId);
    }
  }
};

export const getMediaAspectRatio = (
  media: OptionalMediaSchema['media']
): string => {
  if (hasMedia(media) && media.type === 'image') {
    return [
      media.image.node.mediaDetails.width,
      media.image.node.mediaDetails.height,
    ].join('/');
  }

  return 'auto';
};

export const mediaIsImage = (
  media: OptionalMediaSchema['media']
): media is Extract<OptionalMediaSchema['media'], { type: 'image' }> =>
  media.type === 'image';

export const mediaIsVideo = (
  media: OptionalMediaSchema['media']
): media is Extract<OptionalMediaSchema['media'], { type: 'video' }> =>
  media.type === 'video';

export const mediaIsVimeo = (
  media: OptionalMediaSchema['media']
): media is Extract<OptionalMediaSchema['media'], { type: 'vimeo' }> =>
  media.type === 'vimeo';

export const mediaIsYouTube = (
  media: OptionalMediaSchema['media']
): media is Extract<OptionalMediaSchema['media'], { type: 'youtube' }> =>
  media.type === 'youtube';

export const mediaHasRatio = (
  media: OptionalMediaSchema['media']
): media is Omit<
  Extract<OptionalMediaSchema['media'], { type: 'youtube' | 'vimeo' }>,
  'ratio'
> & {
  ratio: NonNullable<
    Extract<
      OptionalMediaSchema['media'],
      { type: 'youtube' | 'vimeo' }
    >['ratio']
  >;
} =>
  Boolean(
    (mediaIsYouTube(media) || mediaIsVimeo(media)) &&
      media.ratio &&
      media.ratio.height > 0 &&
      media.ratio.width > 0
  );
